// extracted by mini-css-extract-plugin
module.exports = {"site":"oneColumnLayout-module--site--371By","siteContent":"oneColumnLayout-module--siteContent--2XzsB"};